import type { DefaultLine, LegacyLine, LineEntity, LineStylesLegacy } from './schemas';
import { createLineStylesLegacy } from './schemas';

export type CreateLineOptions = {
    horizontalAlign?: LegacyLine['data']['horizontalAlign'];
    styles?: Partial<LineStylesLegacy>;
};

/**
 * Factory for the current legacy line entity — matches the persisted widget JSON
 * shape: `{ id, name: 'line', columnId, data, styles }`. No variant argument:
 * the divider has a single placement (never zero-block).
 */
export function createLegacyLine(options?: CreateLineOptions): LegacyLine {
    return {
        id: '',
        name: 'line',
        columnId: '',
        data: {
            horizontalAlign: options?.horizontalAlign ?? 'M',
        },
        styles: createLineStylesLegacy(options?.styles),
    };
}

/**
 * Factory for a fresh line entity — the same seed as {@link createLegacyLine}, laid
 * out per breakpoint with only the `desktop` leaves set. Identity and the parent
 * link are the host's to fill in.
 */
export function createDefaultLine(): DefaultLine {
    const styles = createLineStylesLegacy();

    return {
        id: '',
        parentId: '',
        entityType: 'widget:line',
        entitySubType: 'default',
        version: 0,
        meta: {
            displayId: null,
            createdAt: Date.now(),
        },
        props: {
            horizontalAlign: { desktop: 'M' },
            borderTopColor: { desktop: styles.borderTopColor },
            borderTopWidth: { desktop: styles.borderTopWidth },
            borderTopStyle: { desktop: styles.borderTopStyle },
            width: { desktop: styles.width },
            margin: { desktop: styles.margin ?? null },
        },
    };
}

/**
 * Convenience entry-point that returns whichever shape is the current default for
 * new line widgets — the versioned entity, via {@link createDefaultLine}.
 */
export function createLine(): LineEntity {
    return createDefaultLine();
}
